/**
 * Pure logic for `help-message-list.vue` (AB#26561), kept out of the `.vue` shell so it can be
 * covered by `node --test` (there is no component test harness in Vue.Frontends).
 */

/** Default "near the bottom" tolerance in pixels. Ported from HelpAssistant.tsx's autoscroll
 * effect (`scrollHeight - scrollTop - clientHeight < 80`). */
export const STICK_TO_BOTTOM_THRESHOLD_PX = 80

/**
 * Whether a scrollable element is close enough to its bottom edge that the message list should
 * keep auto-scrolling to follow new content. Takes plain metrics (rather than an Element) so it
 * can be unit-tested without a DOM.
 * @param {{ scrollHeight: number, scrollTop: number, clientHeight: number }} metrics
 * @param {number} [threshold]
 * @returns {boolean}
 */
export function shouldStickToBottom (metrics, threshold = STICK_TO_BOTTOM_THRESHOLD_PX) {
	const { scrollHeight, scrollTop, clientHeight } = metrics
	return scrollHeight - scrollTop - clientHeight < threshold
}
